function Footer() {
    return (
        <footer>
            <p>Další modlitba online <i>Pobožnost sv. Brigity</i><br />
            více na <a href="https://brigitaonline.cz/" target="_blank">www.brigitaonline.cz</a>
            </p>
            <hr />
            <p>
                Kontakt:<br /><a href="mailto:info@ruzeneconline.cz">info@ruzeneconline.cz</a>
            </p>
            <hr />
            <p>
                <a href="https://www.eracz.cz/2023/09/21/ruzenec-online/" target="_blank">ERA Česká republika</a>
            </p>
        </footer>
    );
}

export default Footer;